//
// Shop: MegaMenu
//

"use strict";

( function($, waTheme) {

    var MegaMenu = (function ($) {

        MegaMenu = function (options) {
            var that = this;

            // DOM
            that.$wrapper = options["$wrapper"];
            that.$aside = that.$wrapper.find(".b-mega-menu__aside");
            that.$content = that.$wrapper.find(".b-mega-menu__content");
            that.$asideItems = that.$aside.find(".b-mega-menu__aside_item");
            that.$contentItems = that.$content.find(".b-mega-menu__content-item");

            // VARS

            // DYNAMIC VARS
            that.timestamp = 0;

            // INIT
            that.init();
        };

        MegaMenu.prototype.init = function () {
            var that = this;

            that.$asideItems.on("mouseenter", function () {
                var category_id = $(this).data("category-id");
                if (category_id) {
                    // hide
                    that.$contentItems.addClass("is-hidden");
                    // show
                    that.$content.find(`[data-category-id="${category_id}"]`).removeClass("is-hidden");
                }
            });

        };

        return MegaMenu;

    })($);

    waTheme.init.shop.MegaMenu = MegaMenu;

    var $wrapper = $('.b-mega-menu');
    if ($wrapper.length) {
        new window.waTheme.init.shop.MegaMenu({
            $wrapper: $wrapper,
        });
    }

})(jQuery, window.waTheme);
